<template>
  <div class="checkboxes-group">
    <p
      class="w-full text-sm"
      :class="{ 'uppercase mb-4': computedOptions && computedOptions.length }"
    >
      <template v-if="computedOptions && computedOptions.length">
        Select all that apply:
      </template>
      <template v-else>
        No available options.
      </template>
    </p>
    <div class="checkboxes-container">
      <div
        class="checkbox-container"
        ref="checkboxContainer"
        :key="`cb_${i}`"
        v-for="(option, i) in computedOptions"
      >
        <input
          :id="$id(underSlugify(option.label))"
          type="checkbox"
          :value="option.value"
          v-model="computedValue"
        />
        <label :for="$id(underSlugify(option.label))">{{ option.label }}</label>
      </div>
    </div>
    <slot name="below-checkboxes" />
  </div>
</template>

<script>
import UsesOptions from "../../elements/UsesOptions";

export default {
  name: "CheckboxesGroup",
  extends: UsesOptions,
  props: {
    value: Array
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.checkboxes-group {
  @apply border border-lightgray py-4 px-5 bg-white;

  .checkboxes-container {
    @apply flex flex-row flex-wrap;

    .checkbox-container {
      @apply w-1/2 pr-4;

      &:not(:last-child):nth-child(odd):not(:nth-last-child(2)) {
        @apply mb-5;
      }
    }
  }
}
</style>
